import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-inner-footer',
  templateUrl: './inner-footer.component.html',
  styleUrls: ['./inner-footer.component.scss']
})
export class InnerFooterComponent implements OnInit {
	public hotelData:any = {};
  public logoImage:string = '';
  public hotel_code:string = '';
  public hotelDataSubscription;
	changeroute() {
	    this.router.navigate(['hotel/manhattantowerfl']);
	}
  constructor(private router: Router,private route: ActivatedRoute,private commonService: CommonService) { 
    this.route.firstChild.params.subscribe((params) => {
      this.hotel_code = params.hotelname
    });
    this.hotelDataSubscription = this.commonService.particularHotelData.subscribe((hotelData:any) => {
      this.hotelData = hotelData;
      this.logoImage = 'assets/img/'+this.hotelData.hotel_id+'.png'; 
    });
  }

  ngOnInit() {
  }

  redirect(url){
    this.router.navigate(['hotel/'+this.hotel_code+'/'+url]);
 }
}
